import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

// const options = { role: ROLE.SUPER_ADMIN };
const options = {};

const path = "admin/runner";

export const RunnerList = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};


export const RunnerAdd = async (values) => {
  return await axiosInstance(options).post(`${path}/add`, values);
};


export const RunnerDelete = async (id) => {
  return await axiosInstance(options).delete(`${path}/delete`, {
    params: {
      o_id: id,
    },
  });
};

export const RunnerDetails = async (id) => {
  return await axiosInstance(options).get(`${path}/details`, {
    params: {
      o_id: id,
    },
  });
};

export const RunnerEdit = async (values) => {
  return await axiosInstance(options).post(`${path}/edit`, values);
};

export const RunnerStatusChange = async (values) => {
  return await axiosInstance(options).post(`${path}/change-status`, values);
};
